import { render, staticRenderFns } from "./MaterialsStatusIndex.vue?vue&type=template&id=20266aac"
import script from "./MaterialsStatusIndex.vue?vue&type=script&lang=js"
export * from "./MaterialsStatusIndex.vue?vue&type=script&lang=js"
import style0 from "./MaterialsStatusIndex.vue?vue&type=style&index=0&id=20266aac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports